import { dFlex } from '@assets/mixins';

export const boxWithHashLinkStyles = {
  ...dFlex('space-between', 'center'),
  width: '100%',
};

export const boxStyles = {
  ...dFlex('space-between', 'flex-start'),
};

export const btnWithHashLinkStyles = {
  ...dFlex('initial'),
  marginLeft: 'auto',
  textDecoration: 'underline',
};

export const linkStyles = {
  ...dFlex('end'),
  display: 'flex',
  marginLeft: 'auto',
  textDecoration: 'underline',
  paddingTop: 8,
  fontSize: '14px',
  lineHeight: '24px',
};
